// Mock data for Ripple VFX Ltd.

// Ripple VFX Projects
export const vfxProjects = [
  {
    id: 1,
    title: "Coming Soon",
    category: "Series",
    image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80",
    year: "2026",
    description: "Coming Soon"
  }
];

// Ripple Digital Projects
export const digitalProjects = [
  {
    id: 1,
    title: "JobFlow",
    category: "Mobile Application",
    image: "/assets/apps/jobflow/jobflow-icon.png",
    previewImage: "/assets/apps/jobflow/jobflow-preview.jpeg",
    status: "Live • iOS & Android",
    description: "Track applications, interviews, offers, and follow-ups in one organized place. JobFlow helps job seekers manage their entire job search with a simple and intuitive workflow.",
    details: "JobFlow replaces messy spreadsheets with a visual Kanban workflow. Track every application from Applied to Interview to Offer, keep follow-up reminders visible, and manage your job search from one private, organized dashboard.",
    modalLabel: "Mobile Application",
    availabilityText: "Available on iOS and Android",
    platforms: ["iOS", "Android"]
  },
  {
    id: 2,
    title: "Ripple VFX Website",
    category: "Web Development",
    image: "/assets/logos/ripple-vfx-logo.png",
    previewImage: "/assets/projects/ripple-vfx-homepage-preview.jpg",
    imageMode: "logo",
    previewMode: "wide",
    status: "Live",
    description: "Corporate website and digital presence for Ripple VFX Ltd., showcasing visual effects services, portfolio work, company information, and contact solutions.",
    details: "A complete corporate website and digital presence designed and developed for Ripple VFX Ltd., bringing the studio's VFX services, portfolio, company information, and contact experience together in one responsive destination.",
    modalLabel: "Web Development",
    availabilityText: "Live website"
  },
  {
    id: 3,
    title: "Coming Soon",
    category: "",
    image: "/assets/projects/project-coming-soon-card.jpg",
    previewImage: "/assets/projects/project-coming-soon-preview.jpg",
    imageMode: "cover",
    previewMode: "wide",
    status: "Coming Soon",
    description: "Coming Soon",
    details: "Coming Soon",
    modalLabel: "",
    availabilityText: "Coming Soon",
    privateProject: true
  }
];

export const clients = [
  { name: "Warner Bros", logo: "WB" },
  { name: "Netflix", logo: "N" },
  { name: "Universal", logo: "U" },
  { name: "Sony Pictures", logo: "SP" },
  { name: "Paramount", logo: "P" },
  { name: "HBO", logo: "HBO" },
  { name: "Apple TV+", logo: "TV+" },
  { name: "Amazon Studios", logo: "AS" }
];

// Ripple VFX Team
export const vfxTeam = [
  {
    id: 1,
    name: "Carle Aubert",
    role: "Co-Founder",
    image: "/assets/team/carle-aubert.png",
    credits: "Co-Founder",
    bio: "With over 10 years of experience in feature film and episodic visual effects, Carle is a Senior VFX Compositor specializing in high-end compositing, CG integration, and photoreal image creation.\n\nDriven by a lifelong passion for cinematic storytelling, he began his creative career as a Video Director and Motion Designer, creating immersive visual experiences for museums and exhibitions before making the transition to feature film visual effects.\n\nHaving worked at leading studios including Sony Pictures Imageworks, Laika, Eyeline Studios, MPC, Method Studios, FuseFX, and Zoic Studios, he has contributed to a wide range of award-winning films and premium television productions.\n\nPassionate about both the artistic and technical sides of compositing, he enjoys solving complex visual challenges while developing efficient Nuke workflows that support production."
  },
  {
    id: 2,
    name: "Aymeric Ballester",
    role: "Co-Founder",
    image: "/assets/team/aymeric-ballester.jpeg",
    credits: "Co-Founder",
    bio: "With over 10 years of experience in feature film visual effects, Aymeric is a VFX Compositor and Nuke Technical Director specializing in compositing, pipeline development, and workflow optimization.\n\nHaving worked at leading studios including DNEG and Eyeline Studios, he has contributed to Academy Award-winning productions such as First Man and Dune.\n\nCombining artistic expertise with technical innovation, he develops scalable Nuke tools, production workflows, and color management solutions that streamline complex pipelines while supporting creative excellence.\n\nKnown for his collaborative approach and practical problem-solving, Aymeric is committed to delivering reliable, efficient solutions that help productions achieve the highest standards of visual quality."
  }
];

// Ripple Digital Team (same people, different titles)
export const digitalTeam = [
  {
    id: 1,
    name: "Carle Aubert",
    role: "Co-Founder",
    image: "/assets/team/carle-aubert.png",
    credits: "Co-Founder",
    bio: "With over 10 years of experience in feature film and episodic visual effects, Carle is a Senior VFX Compositor specializing in high-end compositing, CG integration, and photoreal image creation.\n\nDriven by a lifelong passion for cinematic storytelling, he began his creative career as a Video Director and Motion Designer, creating immersive visual experiences for museums and exhibitions before making the transition to feature film visual effects.\n\nHaving worked at leading studios including Sony Pictures Imageworks, Laika, Eyeline Studios, MPC, Method Studios, FuseFX, and Zoic Studios, he has contributed to a wide range of award-winning films and premium television productions.\n\nPassionate about both the artistic and technical sides of compositing, he enjoys solving complex visual challenges while developing efficient Nuke workflows that support production.\n\nKnown for his attention to detail, collaborative mindset, and calm approach under pressure, Carle is committed to delivering seamless visual effects that serve the story while maintaining the highest standards of quality."
  },
  {
    id: 2,
    name: "Aymeric Ballester",
    role: "Co-Founder",
    image: "/assets/team/aymeric-ballester.jpeg",
    credits: "Co-Founder",
    bio: "With over 10 years of experience in feature film visual effects, Aymeric is a VFX Compositor and Nuke Technical Director specializing in compositing, pipeline development, and workflow optimization.\n\nHaving worked at leading studios including DNEG and Eyeline Studios, he has contributed to Academy Award-winning productions such as First Man and Dune.\n\nCombining artistic expertise with technical innovation, he develops scalable Nuke tools, production workflows, and color management solutions that streamline complex pipelines while supporting creative excellence.\n\nKnown for his collaborative approach and practical problem-solving, Aymeric is committed to delivering reliable, efficient solutions that help productions achieve the highest standards of visual quality."
  }
];

// Ripple VFX Services
export const vfxServices = [
  {
    id: "nuke-compositing",
    icon: "Film",
    title: "Nuke Compositing",
    description: "Expert Nuke compositing services with seamless integration of CGI elements and live-action footage using industry-leading VFX techniques."
  },
  {
    id: "digital-matte-painting",
    icon: "Layers",
    title: "Digital Matte Painting",
    description: "Stunning digital matte painting for environment extensions and photoreal background replacements with cinematic quality."
  },
  {
    id: "color-grading",
    icon: "Palette",
    title: "Color Grading",
    description: "Professional color correction and grading services to achieve the perfect cinematic look for feature films and episodic content."
  },
  {
    id: "motion-graphics",
    icon: "Sparkles",
    title: "Motion Graphics",
    description: "Dynamic motion graphics design for titles, UI elements, broadcast graphics, and commercial VFX production."
  },
  {
    id: "ai-creative-studio",
    icon: "Cpu",
    title: "AI Creative Studio",
    description: "We leverage AI-powered tools and creative solutions to streamline workflows, accelerate production, and deliver innovative VFX while maintaining the highest quality standards."
  }
];

// Ripple Digital Services
export const digitalServices = [
  {
    id: "web-development",
    icon: "Globe",
    title: "Web Development",
    description: "Modern, responsive website development and custom web applications built with cutting-edge technologies to elevate your online presence."
  },
  {
    id: "mobile-app-development",
    icon: "Smartphone",
    title: "Mobile App Development",
    description: "Custom mobile and web application development for iOS and Android designed to deliver seamless user experiences and business value."
  },
  {
    id: "ai-development",
    icon: "Cpu",
    title: "AI Development & Automation",
    description: "Intelligent AI-powered solutions, business automation, and machine learning tools to transform your operations and drive innovation."
  },
  {
    id: "saas-platform",
    icon: "Building",
    title: "SaaS Platform Development",
    description: "Complete SaaS and rental management platforms with booking systems, payment processing, analytics, and scalable infrastructure."
  },
  {
    id: "ai-solutions",
    icon: "Sparkles",
    title: "AI Solutions for Business",
    description: "Full-service AI consulting, implementation, and custom AI tool development to help your business leverage artificial intelligence effectively."
  },
  {
    id: "digital-product-design",
    icon: "Palette",
    title: "Digital Product Design",
    description: "Professional UI/UX design, branding, digital marketing materials, and product design services for web and mobile applications."
  }
];

// Contact Information (shared)
export const contactInfo = {
  email: "contact@ripplevfxstudios.com",
  address: {
    street: "2450-57 Lobb Avenue",
    city: "Port Coquitlam",
    province: "BC",
    postal: "V3C 6G8",
    country: "Canada"
  }
};

// Core values
export const values = [
  "Excellence",
  "Innovation",
  "Collaboration",
  "Integrity",
  "Creativity",
  "Passion"
];